const state = {
	article: [],
	note: [],
	graph: []
}

const getters = {
}

const actions = {
	addItem({ commit }, data) {
		commit('addItem', {data})
	},
	removeItem({ commit }, data) {
		commit('removeItem', {data})
	},
	isItemAdded({state}, data) {
		if (typeof state[data.type] === 'undefined' || state[data.type].length === 0) return false;

		for (var i = 0; i <= state[data.type].length; i++) {
			if (state[data.type][i]===data.itemId) {
				return true;
			}
		}
		return false;
	},
	getAllIds({state}) {
		return state.article.concat(state.note).concat(state.graph)
	}
}

const mutations = {
	addItem (state, {data}) {
		state[data.type].push(data.itemId)
	},
	removeItem (state, {data}) {
		var index = state[data.type].indexOf(data.itemId);
		if (index > -1) {
			state[data.type].splice(index, 1);
		}
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}